'use client';

import React from 'react';
import styled from 'styled-components';
import Button from '@storeblocks/button';

import useTranslation from '../../translation/useTranslation';
import { useCart } from './state';

function Cart() {
  const { t } = useTranslation();
  const { cart } = useCart();

  const cartPresent = cart.id && cart.count;

  if (!cartPresent) {
    return null;
  }

  return (
    <CartBase>
      <Header>
        <span>
          {t('notification.cart.title')}
        </span>
        <i>shopping-basket-in</i>
      </Header>
      <Content>
        {t('notification.cart.description')
          .replace('{}', cart.count as string)}
        <Button
          variant="outlined"
          as="a"
          href={cart.href}
        >
          {t('notification.cart.link')}
        </Button>
      </Content>
    </CartBase>
  );
}

export default Cart;

export const CartBase = styled.div`
  font-size: 16px;
  line-height: 24px;

  border-radius: 8px;
  overflow: hidden;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 16px;
  font-weight: 400;
  color: var(--navbar-toggle-accent-color, #700);
  background: var(--navbar-toggle-accent-background, #aa0600);

  & > i {
    font-size: 24px;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 16px;

  font-size: 16px;
  line-height: 24px;
  color: var(--navbar-toggle-accent-color, #700);
  background: var(--navbar-toggle-accent-background, #FFF0F0);

  padding: 16px;
`;
